"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventConfigurable = void 0;
class EventConfigurable {
    constructor(_data, eventProperties = { isBroadcast: false }) {
        this._data = _data;
        this.eventProperties = eventProperties;
    }
    get data() {
        return this._data;
    }
    isBroadcast() {
        return this.eventProperties.isBroadcast;
    }
    setBroadcast(isBroadcast) {
        this.eventProperties.isBroadcast = isBroadcast;
    }
    clone() {
        return new EventConfigurable(this._data, Object.assign({}, this.eventProperties));
    }
}
exports.EventConfigurable = EventConfigurable;
//# sourceMappingURL=event.js.map